import React from 'react';
import Footer from "../template/Footer";
import Header from "../template/Header";
import HomeSection from "../template/HomeSection";
import { Link } from 'react-router-dom';  // Import Link
import '../../css/main.module.css'; // Import the CSS file

export default function NotFound() {
  return (
    <>     
      <div className="not-found-container">
          <h1 className="not-found-heading">متاسفانه صفحه مورد نظر پیدا نشد!</h1>
          <p className="not-found-message">صفحه‌ای که دنبالش می‌گردید وجود ندارد.</p>
          {/* Add a link back to the homepage */}
          <Link to="/" className="back-to-home-link">بازگشت به صفحه اصلی</Link>
      </div>     
    </>
  );
}